const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅不缓冲',
    desc: '自研智能加速引擎，多线路自动切换技术，确保久久视频、小蓝视频、豆花视频所有内容播放稳定流畅，高峰时段也不卡顿。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-stack-line',
    title: '多平台内容聚合',
    desc: '一站式接入久久视频、小蓝视频、豆花视频三大稳定平台，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，省去多平台切换的麻烦。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新不等待',
    desc: '内容团队每日同步各大平台最新资源，热门剧集、电影、综艺上线后24小时内完成更新，让你第一时间看到想看的内容。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">平台优势</h2>
            <p className="text-sm md:text-base text-foreground-600">
              为什么选择宅男视频？三大核心优势让观影更畅快
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {features.map((feat, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center transition-all duration-300 hover:border-primary-200">
                <div className={`w-14 h-14 rounded-xl ${feat.color} flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}